import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import { SAVE_REALMS, SAVE_REALM_USERS } from "@/store/mutation-types";

export default {
  actions: {
    saveRealm: async ({dispatch}, payload) => {
        return ApiRequest.explorePost("realm", payload.realm, GetHeaders.projectHeaders()).then(
            () => {
              dispatch("loadRealms");
            }
        );
    },
    loadRealms: async ({ commit }) => {
        return ApiRequest.exploreGet("realms", GetHeaders.projectHeaders()).then(
          res => {
            commit(SAVE_REALMS, { realms: res.data });
          }
        );
    },
    saveUser: async ({dispatch}, payload) => {
        return ApiRequest.explorePost("realmuser", payload.user, GetHeaders.projectHeaders()).then(
            () => {
              dispatch("loadUsers");
            }
        );
    },
    updateUserPass: async (_, payload) => {
      return ApiRequest.explorePost('realmuserpassword',
      payload,
      GetHeaders.projectHeaders()
      ).then(response => {
        return response.data
      })
    },
    updateUserStatus: async (_, payload) => {
      return ApiRequest.explorePatch(`update_user_status/${payload.user_id}`,
      { status: payload.status },
      GetHeaders.projectHeaders()
      ).then(response => {
        return response.data
      })
    },
    updateRealmUser: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost('realmuserupdate',
      payload.user,
      GetHeaders.projectHeaders()
      ).then(response => {
        dispatch("loadUsers");
        return response.data
      })
    },
    updateUserAccess: async (_, payload) => {
      return ApiRequest.explorePost('realmuseraccess',
      payload,
      GetHeaders.projectHeaders()
      ).then(response => {
        return response.data
      })
    },
    loadUsers: async ({ commit }) => {
      return ApiRequest.exploreGet("realmusers", GetHeaders.projectHeaders()).then(
        res => {
          commit(SAVE_REALM_USERS, { users: res.data });
        }
      );
    },
    loadUser: async (_, payload) => {
      return ApiRequest.exploreGet(
        "users/" + payload.id,
        GetHeaders.projectHeaders()
      ).then(res => {
        return ParseUser.parse(res.data);
      });
    },
    loadRealmNames: async (_, payload) => {
      return ApiRequest.exploreGet("list_all_realms", GetHeaders.projectHeaders()).then(
        res=>{
          return res.data;
        }
      )
    },
    fetchRealmData: async (_, payload) => {
      console.log(payload)
      return ApiRequest.exploreGet(
        `realm_data?name=${payload}`,
        GetHeaders.projectHeaders()
      ).then(res=>{
        return res.data;
      });
    },
    migrateRealmSettings: async (_,payload)=>{
      return ApiRequest.explorePost("migrate_realm_settings",payload,GetHeaders.projectHeaders()).then(res=>{
        return res.data;
      })
    }
  },
  getters: {
    userById: state => payload => state.realmUsers.find(u => u._id === payload.id)
  },
  mutations: {
    [SAVE_REALM_USERS](state, payload) {
        state.realmUsers = payload.users;
    },
    [SAVE_REALMS](state, payload) {
        state.realms = payload.realms;
    }
  },
  state: {
    realms: [],
    realmUsers: []
  }
};
